import { cddTierMeta } from './cddTierMeta'

export default function CddTierBadge({ tier, size = 'default', className = '' }) {
  const meta = cddTierMeta(tier)
  const compact = size === 'compact'
  const padding = compact ? 'px-2 py-0.5 text-[11px]' : 'px-2.5 py-0.5 text-xs'

  if (!meta) {
    return (
      <span
        className={`inline-flex items-center font-semibold rounded-full border bg-gray-100 text-gray-500 border-gray-200 ${padding} ${className}`}
        title="CDD intensity tier not yet classified"
      >
        CDD —
      </span>
    )
  }

  return (
    <span
      className={`inline-flex items-center font-semibold rounded-full border ${padding} ${className}`}
      style={{ backgroundColor: meta.bg, color: meta.color, borderColor: meta.border }}
      title={meta.desc}
    >
      CDD {meta.label}
    </span>
  )
}
